// --- 汽车保险 --- //

export default [
  {
    name: 'applyInfo',
    path: '/carInsuranceSystem/applyInfo',
    meta: { title: '保险申请管理' },
    component: require('business/carInsuranceSystem/applyInfoManagement/applyInfo/list.vue').default
  },
  {
    name: 'carInsuranceDetail',
    path: '/carInsuranceSystem/applyInfo/detail',
    meta: { title: '保险申请详情' },
    component: require('business/carInsuranceSystem/applyInfoManagement/applyInfo/detail.vue').default
  },
  {
    name: 'carInsuranceFeedback',
    path: '/carInsuranceSystem/applyInfo/feedback',
    meta: { title: '投保反馈' },
    component: require('business/carInsuranceSystem/applyInfoManagement/applyInfo/feedback.vue').default
  }
]
